import { TextField, IconButton, Button, Tooltip } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";

const PricingRow = ({ range, isLast, onChange, onRemove, disableDelete, classes, highlighted, warningFields }) => {
  return (
    <tr>
      <td className={classes.pricingRubricTableCell}>
        <Tooltip
          title={highlighted && range.status !== 'new' ? "MIN of this row updated automatically" : ""}
          arrow
        >
          <Authorize profile={permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_FIELD_EDIT}>
            <TextField
              type="number"
              value={range.minMiles}
              size="small"
              variant="outlined"
              className={classes.pricingRubricInput}
              placeholder="From Miles"
              disabled
              style={highlighted && range.status !== 'new' ? { backgroundColor: '#fff9c4' } : {}}
            />
          </Authorize>
        </Tooltip>
      </td>

      <td className={classes.pricingRubricTableCell}>
        <Tooltip
          title={warningFields ? '"To" value should be more than "From" value.' : ''}
          arrow
        >
          <span>
            {isLast ? (
              <TextField
                value={`${range.minMiles + 1}+`}
                size="small"
                variant="outlined"
                className={classes.pricingRubricInput}
                disabled
              />
            ) : (
              <Authorize profile={permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_FIELD_EDIT}>
                <TextField
                  type="number"
                  value={range.maxMiles}
                  onChange={(e) => onChange('maxMiles', e.target.value)}
                  size="small"
                  variant="outlined"
                  className={classes.pricingRubricInput}
                  placeholder="To Miles"
                  style={warningFields ? { backgroundColor: '#f88080ff' } : {}}
                />
              </Authorize>
            )}
          </span>
        </Tooltip>

      </td>


      <td className={classes.pricingRubricTableCell}>
        <Authorize profile={permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_FIELD_EDIT}>
          <TextField
            type="number"
            value={range.pricePerMileDriven}
            onChange={(e) => onChange('pricePerMileDriven', e.target.value)}
            size="small"
            variant="outlined"
            className={classes.pricingRubricInput}
            placeholder="Driven $ per mile"
          />
        </Authorize>
      </td>

      <td className={classes.pricingRubricTableCell}>
        <Authorize profile={permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_FIELD_EDIT}>
          <TextField
            type="number"
            value={range.pricePerMileTowed}
            onChange={(e) => onChange('pricePerMileTowed', e.target.value)}
            size="small"
            variant="outlined"
            className={classes.pricingRubricInput}
            placeholder="Towed $ per mile"
          />
        </Authorize>
      </td>

      {!isLast && (
        <td className={classes.pricingRubricTableCell}>
          <Authorize profile={permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_FIELD_EDIT}>
            <IconButton onClick={onRemove} size="small" disabled={disableDelete}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Authorize>
        </td>
      )}
    </tr>
  );
};

export default PricingRow;
